import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Space, Form, Input, Button, Table, DatePicker } from 'antd';
import { PlusSquareFilled, DownloadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import _ from 'lodash';
import UrlParse from 'url-parse';
import LabelHelper from '../../helpers/Label';
import GeneralHelper from '../../helpers/general';

const { RangePicker } = DatePicker;

const ApplicationListPage = props => {
	const searchFormRef = useRef();

	const { getApplications, pageProps, resetPage, resetMeta, resetListPage, location, history } = props;
	const { applications, loading } = pageProps;
	const { query } = UrlParse(location.search, true);

	// states
	const [searchBody, setSearchBody] = useState({ date_of_trip: [], keyword: null });

	useEffect(() => {
		getApplications(searchBody);
	}, [getApplications, searchBody]);

	const formattedApplication =
		applications &&
		applications.length > 0 &&
		applications.map((application, index) => {
			const firstTrip = application.trips.length > 0 ? application.trips[0] : null; // if there is no trips, then make a temporary trip
			const remainingTrips = application.trips.length > 1 ? application.trips.slice(1) : [];

			const children =
				remainingTrips.length > 0 &&
				remainingTrips.map(remainingTrip => ({
					date_of_trip: application.date_of_trip,
					guest_name: application.guest_name,
					application_id: application._id,
					trips: remainingTrip
				}));

			return {
				key: index,
				custom_id: application.custom_id,
				date_of_trip: application.date_of_trip,
				// guest_name: application.guest_name,
				trips: firstTrip,
				children: children,
				application_id: application._id,
				guest_type: application.guest_type,
				guest_staff_email: application.guest_staff_email,
				guest_staff_name: application.guest_staff_name,
				guest_vip_name: application.guest_vip_name
			};
		});

	const [windowSize, setWindowSize] = useState(window.innerWidth);

	useEffect(() => {
		resetPage();
		resetMeta();
		const handleResize = () => setWindowSize(window.innerWidth);

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
			resetListPage();
		};
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		getApplications();
	}, [getApplications]);

	const showMessage = message => {
		return (
			<div
				style={{
					display: 'inline-block',
					border: '1px solid',
					borderColor:
						message === 'approved' ? '#5EC82A' : message === 'rejected' || message === 'cancelled' ? '#FF4D4F' : message === 'pending' ? '#FAB328' : null,
					borderRadius: '4px',
					padding: '3px 3px',
					justifyContent: 'space-between',
					background:
						message === 'approved' ? '#F6FFED' : message === 'rejected' || message === 'cancelled' ? '#FFF2F0' : message === 'pending' ? '#FFFBE6' : null
				}}
			>
				<span>
					<span
						style={{
							color: message === 'approved' ? '#5EC82A' : message === 'rejected' || message === 'cancelled' ? '#FF4D4F' : message === 'pending' ? '#FAB328' : null
						}}
					>
						{' '}
						{LabelHelper.applicationStatus(message)}
					</span>
				</span>
			</div>
		);
	};

	const handleTableChange = pagination => {
		const { current, pageSize } = pagination;
		props.history.push(`/applications?page=${current}&limit=${pageSize}`);
	};

	const handleSearchFilterChange = ({ key, value }) => {
		setSearchBody({ ...searchBody, [key]: value });
	};

	const handleSearch = (formValues) => {
		console.log({ formValues });
	};

	const confirmDownloadUserManual = async () => {
		const shouldDownload = window.confirm('Do you want to download the User Manual PDF file?');
		if (shouldDownload) {
			try {
				const file = `${GeneralHelper.getImageBasePath()}/assets/CSO Official Transport Booking System User Manual (250117).pdf`;
				const encodedUri = encodeURI(file);
				const a = document.createElement('a');
				document.body.appendChild(a);
				a.href = encodedUri;
				a.download = 'CSO Official Transport Booking System User Manual (250117)';
				a.click();
			} catch (error) {
				console.error('Error downloading the PDF:', error);
			}
		}
	};

	const columns = [
		{
			title: 'Booking ID',
			dataIndex: 'custom_id',
			key: 'custom_id',
			width: '20%'
		},
		{
			title: 'Guest (Name/Email)',
			dataIndex: 'guest_name',
			key: 'guest_name',
			render: (guest_name, application) => (
				application.guest_type === 'vip'
					? application.guest_vip_name
					: <>
						{application.guest_staff_name}
						<br/>
						{application.guest_staff_email}
					</>

			),
			width: '20%'
		},
		{
			title: 'Trip Date',
			dataIndex: 'date_of_trip',
			key: 'date_of_trip',
			render: date_of_trip => <>{date_of_trip && dayjs(date_of_trip).format('YYYY-MM-DD')}</>,
			width: '10%'
		},
		{
			title: 'Time of Departure',
			dataIndex: 'trips',
			key: 'trips',
			render: trips => {
				return (
					<span>{trips.time_of_departure ? dayjs(trips.time_of_departure).format('HH:mm') : 'No trips'}</span>
				);
			}
		},
		{
			title: 'Trips',
			dataIndex: 'trips',
			key: 'trips',
			render: trips => {
				if (!_.isEmpty(trips.status)) {
					return (
						<>
							<div style={{ marginBottom: 5 }}>
								{trips.tripString} {showMessage(trips.status ? (trips.status === 'draft' ? 'pending' : trips.status) : 'pending')}
							</div>

							{trips.inside_hkust_pickup ? (
								<>
									<div style={{ marginBottom: 5 }}>From: Inside HKUST</div>

									<div style={{ display: 'flex' }}>
										<div style={{ width: '4.5%' }}>
											<div
												style={{
													width: '20px',
													height: '20px',
													borderRadius: '50%',
													backgroundColor: '#003366',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													fontSize: '12px'
												}}
											>
												<span style={{ color: '#FFFFFF' }}>{trips.from.length}</span>
											</div>
										</div>

										<div style={{ width: '95.5%' }}>
											<div style={{ marginLeft: 10 }}>{trips.from.join(',')}</div>
										</div>
									</div>
								</>
							) : (
								<div style={{ marginBottom: 5 }}>From: {trips.from.join(',')}</div>
							)}

							{trips.inside_hkust_drop_off ? (
								<>
									<div style={{ marginBottom: 5 }}>To: Inside HKUST</div>
									<div>{trips.to.join(',')}</div>
								</>
							) : (
								<>
									<div style={{ marginBottom: 5 }}>To: {trips.to.join(',')}</div>
								</>
							)}
						</>
					);
				} else {
					return (
						<div>
							<span>No Trip(s)</span>
						</div>
					);
				}
			},
			width: '40%'
		},

		{
			title: 'Action',
			dataIndex: 'application_id',
			key: 'application_id',
			render: application_id => {
				return (
					<Space size="middle">
						<Link to={`/applications/id/basic?id=${application_id}`}>Edit</Link>
					</Space>
				);
			},
			width: '10%'
		}
	];

	return (
		<React.Fragment>
			<Row>
				<Col
					span={22}
					offset={1}
				>
					<div className="main-content">
						<Row
							justify="space-between"
							style={{ marginBottom: 18 }}
						>
							<Col
								lg={{ span: 6 }}
								md={{ span: 6 }}
								sm={{ span: 24 }}
								xs={{ span: 24 }}
								style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
							>
								<h1 style={{ color: '#003366' }}>My Bookings</h1>
								<Button
									icon={<DownloadOutlined/>}
									onClick={() => confirmDownloadUserManual()}
								>
									User Manual
								</Button>
								{/* <div style={{ float: 'left' }}>
									<h4 style={{ fontWeight: 'normal', fontSize: 20 }}>Booking List</h4>
								</div> */}
							</Col>

							<Col
								lg={{ span: 18 }}
								md={{ span: 18 }}
								sm={{ span: 24 }}
								xs={{ span: 24 }}
								style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} // Align the buttons and form to the right
							>
								<Form
									layout="vertical"
									onFinish={handleSearch}
									ref={searchFormRef}
									style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}
								>
									<Row
										gutter={[8]}
										justify="end"
									>
										<Col
											style={{ display: 'flex', justifyContent: 'flex-end' }}
										>
											<Form.Item name="guest_name">
												<Input
													placeholder="Search by Guest Name"
													onBlur={(e) => {
														handleSearchFilterChange({
															key: 'guest_name',
															value: e.target.value
														});
													}}
													onKeyPress={(e) => {
														if (e.key === 'Enter') {
															handleSearchFilterChange({
																key: 'guest_name',
																value: e.target.value
															});
														}
													}}
													onChange={(e) => {
														if (e.target.value === '') {
															handleSearchFilterChange({
																key: 'guest_name',
																value: null
															});
														}
													}}
													allowClear
													style={{ width: '100%' }}
												/>
											</Form.Item>
										</Col>
										<Col
											style={{ display: 'flex', justifyContent: 'flex-end' }}
										>
											<Form.Item name="date">
												<RangePicker
													onChange={(value) => {
														console.log('Trigger date change');
														handleSearchFilterChange({
															key: 'date_of_trip',
															value: value ? [dayjs(value[0]).format('YYYY-MM-DD'), dayjs(value[1]).format('YYYY-MM-DD')] : []
														});

														if (value === '') {

														}
													}}
													allowClear
												/>
											</Form.Item>
										</Col>
										<Col
											style={{ display: 'flex', justifyContent: 'flex-end' }}
										>
											<Form.Item name="keyword">
												<Input
													placeholder="Search by Booking ID, Guest Name/Email, Address"
													onBlur={(e) => {
														handleSearchFilterChange({
															key: 'keyword',
															value: e.target.value
														});
													}}
													onChange={(e) => {
														if (e.target.value === '') {
															handleSearchFilterChange({
																key: 'keyword',
																value: null
															});
														}
													}}
													allowClear
													style={{ width: '100%' }}
												/>
											</Form.Item>
										</Col>
										<Col
											style={{ display: 'flex', justifyContent: 'flex-end' }}
										>
											<Button
												onClick={() => props.history.push('/favorite-destination')}
												style={{ color: '#0088FF', borderColor: '#0088FF', marginTop: windowSize < 413 ? 10 : 0 }}
											>
												Favorite Location
											</Button>
										</Col>
										<Col
											style={{ display: 'flex', justifyContent: 'flex-end' }}
										>
											<Button
												type="primary"
												icon={<PlusSquareFilled />}
												onClick={() => history.push('/applications/create')}
												style={{ marginTop: windowSize < 434 ? 10 : 0 }}
											>
												Add Booking
											</Button>
										</Col>
										<Space>
										</Space>
									</Row>
								</Form>
							</Col>
						</Row>

						{
							<Row>
								<Col span={24}>
									<Table
										loading={loading}
										dataSource={formattedApplication}
										columns={columns}
										pagination={{
											position: ['bottomRight'],
											showSizeChanger: true,
											total: formattedApplication.length,
											current: query.page || 1,
											pageSize: query.limit || 10
										}}
										onChange={handleTableChange}
										scroll={{
											x: 1000
										}}
									/>
								</Col>
							</Row>
						}
					</div>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default ApplicationListPage;
